// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// // import { useUser } from "../../pages/UserContext";
// import "./Navbar.css";
// import Logo from "../../assets/Logo.png";

// const Navbar = ({ sidebarOpen, toggleSidebar }) => {
//   const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
//   const [projects, setProjects] = useState([]);
//   const [selectedProject, setSelectedProject] = useState("");
//   const navigate = useNavigate();
//   // const { username, setUsername } = useUser(); // Access username and setUsername from context
//   const username = sessionStorage.getItem('username');

//   const toggleProfileDropdown = () => {
//     setProfileDropdownOpen(!profileDropdownOpen);
//   };

//   const handleClickOutside = (event) => {
//     if (!event.target.closest("#profile-dropdown") && !event.target.closest("#profile-dropdown-menu")) {
//       setProfileDropdownOpen(false);
//     }
//   };

//   useEffect(() => {
//     if (profileDropdownOpen) {
//       document.addEventListener("click", handleClickOutside);
//     } else {
//       document.removeEventListener("click", handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener("click", handleClickOutside);
//     };
//   }, [profileDropdownOpen]);

//   // Fetch projects from the backend
//   useEffect(() => {
//     const fetchProjects = async () => {
//       try {
//         const response = await axios.get("https://redoms-backend-dev.m-devsecops.com/get_project_names");
//         const formattedProjects = response.data.map((project) => ({
//           id: project.project_id,
//           name: project.project_name,
//         }));
//         setProjects(formattedProjects);

//         // Initialize selected project from localStorage
//         const storedProjectId = localStorage.getItem("selectedProject");
//         const storedProjectName = localStorage.getItem("selectedProjectName");

//         if (storedProjectId && storedProjectName) {
//           setSelectedProject(storedProjectName);
//         } else if (formattedProjects.length > 0) {
//           setSelectedProject(formattedProjects[0].name);
//           localStorage.setItem("selectedProject", formattedProjects[0].id);
//           localStorage.setItem("selectedProjectName", formattedProjects[0].name);
//         }
//       } catch (error) {
//         console.error("Error fetching projects:", error);
//       }
//     };

//     fetchProjects();
//   }, []);

//   // Handle project change
//   const handleProjectChange = (event) => {
//     const selectedProjectName = event.target.value;
//     const selectedProjectData = projects.find(project => project.name === selectedProjectName);

//     if (selectedProjectData) {
//       setSelectedProject(selectedProjectName);
//       localStorage.setItem("selectedProject", selectedProjectData.id);
//       localStorage.setItem("selectedProjectName", selectedProjectData.name);

//       // Refresh the page to load the new project
//       window.location.reload();
//     }
//   };

//   // Handle logout
//   const handleLogout = () => {
//     // setUsername(""); // Clear username in context
//     const logoutUrl = `http://localhost:8080/realms/ReDoms/protocol/openid-connect/logout?post_logout_redirect_uri=http://localhost:3000&client_id=Redoms`; 
//     window.location.href = logoutUrl;
//   };

//   return (
//     <div
//       id="Navbar"
//       className="navbar-container"
//       style={{
//         marginLeft: sidebarOpen ? 300 : 60,
//         transition: "margin-left 0.1s",
//       }}
//     >
//       <div className="navbar-left">
//         <img id="Logo" className="logo" width="120" src={Logo} alt="Logo" />
//       </div>
//       <div className="navbar-right">
//         <div>
//           <select
//             value={selectedProject}
//             onChange={handleProjectChange}
//             className="project-dropdown"
//           >
//             <option value="">Select Project</option>
//             {projects.map((project) => (
//               <option key={project.id} value={project.name}>
//                 {project.name}
//               </option>
//             ))}
//           </select>
//         </div>
//         <div className="navbar-right">
//           <div className="profile-container">
//             <i
//               id="profile-dropdown"
//               className="profile-icon fa-solid fa-user"
//               onClick={toggleProfileDropdown}
//             ></i>
//             {profileDropdownOpen && (
//               <div
//                 className="profile-dropdown"
//                 id="profile-dropdown-menu"
//               >
//                 <div className="profile-info">
//                   <p className="profile-username">{username}</p> {/* Display username from context */}
//                 </div>
//                 <button
//                   className="logout-button"
//                   onClick={handleLogout}
//                 >
//                   Logout
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Navbar;


// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { signOut } from "firebase/auth";
// import { auth } from "../../firebase"; // Import your Firebase auth instance
// import axios from "axios";
// import "./Navbar.css";
// import Logo from "../../assets/Logo.png";

// const Navbar = ({ sidebarOpen, toggleSidebar }) => {
//   const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
//   const [projects, setProjects] = useState([]);
//   const [selectedProject, setSelectedProject] = useState("");
//   const navigate = useNavigate();
//   const username = sessionStorage.getItem("username"); // Get username from sessionStorage

//   const toggleProfileDropdown = () => {
//     setProfileDropdownOpen(!profileDropdownOpen);
//   };

//   const handleClickOutside = (event) => {
//     if (!event.target.closest("#profile-dropdown") && !event.target.closest("#profile-dropdown-menu")) {
//       setProfileDropdownOpen(false);
//     }
//   };

//   useEffect(() => {
//     // Check if username exists, if not, log out
//     if (!username) {
//       handleLogout();
//       return;
//     }

//     if (profileDropdownOpen) {
//       document.addEventListener("click", handleClickOutside);
//     } else {
//       document.removeEventListener("click", handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener("click", handleClickOutside);
//     };
//   }, [profileDropdownOpen, username]);

//   // Fetch projects from the backend
//   useEffect(() => {
//     const fetchProjects = async () => {
//       try {
//         const response = await axios.get("https://redoms-backend-dev.m-devsecops.com/get_project_names");
//         const formattedProjects = response.data.map((project) => ({
//           id: project.project_id,
//           name: project.project_name,
//         }));
//         setProjects(formattedProjects);

//         // Initialize selected project from localStorage
//         const storedProjectId = localStorage.getItem("selectedProject");
//         const storedProjectName = localStorage.getItem("selectedProjectName");

//         if (storedProjectId && storedProjectName) {
//           setSelectedProject(storedProjectName);
//         } else if (formattedProjects.length > 0) {
//           setSelectedProject(formattedProjects[0].name);
//           localStorage.setItem("selectedProject", formattedProjects[0].id);
//           localStorage.setItem("selectedProjectName", formattedProjects[0].name);
//         }
//       } catch (error) {
//         console.error("Error fetching projects:", error);
//       }
//     };

//     fetchProjects();
//   }, []);

//   // Handle project change
//   const handleProjectChange = (event) => {
//     const selectedProjectName = event.target.value;
//     const selectedProjectData = projects.find((project) => project.name === selectedProjectName);

//     if (selectedProjectData) {
//       setSelectedProject(selectedProjectName);
//       localStorage.setItem("selectedProject", selectedProjectData.id);
//       localStorage.setItem("selectedProjectName", selectedProjectData.name);

//       // Refresh the page to load the new project
//       window.location.reload();
//     }
//   };

//   // Handle logout with Firebase
//   const handleLogout = async () => {
//     try {
//       await signOut(auth); // Sign out from Firebase
//       sessionStorage.removeItem("username"); // Clear username from sessionStorage
//       navigate("/login", { replace: true }); // Redirect to login page and replace history
//     } catch (error) {
//       console.error("Error logging out:", error);
//     }
//   };

//   return (
//     <div
//       id="Navbar"
//       className="navbar-container"
//       style={{
//         marginLeft: sidebarOpen ? 300 : 60,
//         transition: "margin-left 0.1s",
//       }}
//     >
//       <div className="navbar-left">
//         <img id="Logo" className="logo" width="120" src={Logo} alt="Logo" />
//       </div>
//       <div className="navbar-right">
//         <div>
//           <select
//             value={selectedProject}
//             onChange={handleProjectChange}
//             className="project-dropdown"
//           >
//             <option value="">Select Project</option>
//             {projects.map((project) => (
//               <option key={project.id} value={project.name}>
//                 {project.name}
//               </option>
//             ))}
//           </select>
//         </div>
//         <div className="navbar-right">
//           <div className="profile-container">
//             <i
//               id="profile-dropdown"
//               className="profile-icon fa-solid fa-user"
//               onClick={toggleProfileDropdown}
//             ></i>
//             {profileDropdownOpen && (
//               <div className="profile-dropdown" id="profile-dropdown-menu">
//                 <div className="profile-info">
//                   <p className="profile-username">{username}</p> {/* Display username from sessionStorage */}
//                 </div>
//                 <button className="logout-button" onClick={handleLogout}>
//                   Logout
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Navbar;

import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
import axios from "axios";
import Logo from "../../assets/Logo.png";
import useKeycloakAuth from "../../hooks/useKeycloakAuth";
import apiClient from "../../pages/keycloak/axiosInstance";

const Navbar = ({ sidebarOpen, toggleSidebar }) => {
  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
  const [allowedProjects, setAllowedProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");

  // const navigate = useNavigate();
  const username = sessionStorage.getItem("username");
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const { logout } = useKeycloakAuth();

  // Extract project name from role: project_NHPC_300MW_view → NHPC_300MW
  const extractProjectName = (role) => {
    const match = role.match(/^project_(.+)_view$/);
    return match ? match[1] : null;
  };

  const getUserRoles = () => {
    const stored = sessionStorage.getItem("userRoles");
    if (!stored) return [];
    try {
      const parsed = JSON.parse(stored);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return stored.split(",").map(r => r.trim()).filter(Boolean);
    }
  };

  useEffect(() => {
    const loadProjects = async () => {
      try {
        const response = await apiClient.get('get_project_names');
        const projects = response.data.map(p => ({
          id: p.project_id,
          name: p.project_name,
        }));

        const userRoles = getUserRoles();
        const allowedNames = userRoles
          .map(extractProjectName)
          .filter(Boolean);

        const filtered = projects.filter(p => allowedNames.includes(p.name));

        setAllowedProjects(filtered);

        // Save to sessionStorage so ViewProject can use it
        sessionStorage.setItem("allowedProjectNames", JSON.stringify(allowedNames));

        // Restore selected project
        const savedName = localStorage.getItem("selectedProjectName");
        const stillAllowed = filtered.some(p => p.name === savedName);

        if (stillAllowed && savedName) {
          setSelectedProject(savedName);
        } else if (filtered.length > 0) {
          const first = filtered[0];
          setSelectedProject(first.name);
          localStorage.setItem("selectedProject", first.id);
          localStorage.setItem("selectedProjectName", first.name);
        }
      } catch (error) {
        console.error("Error loading projects:", error);
        setAllowedProjects([]);
        sessionStorage.setItem("allowedProjectNames", JSON.stringify([]));
      }
    };

    loadProjects();
  }, [baseURL]);

  const handleProjectChange = (e) => {
    const name = e.target.value;
    const project = allowedProjects.find(p => p.name === name);
    if (project) {
      setSelectedProject(name);
      localStorage.setItem("selectedProject", project.id);
      localStorage.setItem("selectedProjectName", project.name);
      window.location.reload();
    }
  };

  const handleLogout = () => {
    logout();
    localStorage.clear();
    sessionStorage.clear();
    // window.location.href = "/";
  };

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 shadow-sm transition-all duration-300"
      style={{
        marginLeft: sidebarOpen ? "300px" : "60px",
        width: sidebarOpen ? "calc(100% - 300px)" : "calc(100% - 60px)",
      }}
    >
      <div className="flex items-center justify-between h-16 px-6">
        <div className="flex-shrink-0">
          <img src={Logo} alt="Logo" className="h-10 w-auto" />
        </div>

        <div className="flex-1 max-w-md mx-8">
          {allowedProjects.length > 0 ? (
            <select
              value={selectedProject}
              onChange={handleProjectChange}
              className="w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select Project</option>
              {allowedProjects.map(project => (
                <option key={project.id} value={project.name}>
                  {project.name}
                </option>
              ))}
            </select>
          ) : (
            <div className="text-center text-red-600 font-medium py-2">
              No projects assigned
            </div>
          )}
        </div>

        <div className="relative">
          <button
            onClick={() => setProfileDropdownOpen(prev => !prev)}
            className="flex items-center space-x-3 text-gray-700 hover:text-gray-900"
          >
            <div className="w-10 h-10 rounded-full bg-gradient-to-r from-gray-500 to-gray-600 flex items-center justify-center text-white font-semibold text-sm">
              {username?.[0]?.toUpperCase() || "U"}
            </div>
            <span className="hidden md:block text-sm font-medium">{username || "User"}</span>
          </button>

          {profileDropdownOpen && (
            <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-10">
              <div className="px-4 py-3 border-b border-gray-100">
                <p className="text-sm font-semibold text-gray-900">{username || "User"}</p>
                <p className="text-xs text-gray-500">User Account</p>
              </div>
              <button
                onClick={handleLogout}
                className="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50"
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;

// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import Logo from "../../assets/Logo.png";
// import useKeycloakAuth from "../../hooks/useKeycloakAuth";

// const Navbar = ({ sidebarOpen, toggleSidebar }) => {
//   const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
//   const [projects, setProjects] = useState([]);
//   const [selectedProject, setSelectedProject] = useState("");
//   const navigate = useNavigate();

//   // Get auth data from Keycloak
//   const { username, keycloak } = useKeycloakAuth();

//   const baseURL = process.env.REACT_APP_API_BASE_URL;

//   const USERNAMES_RESTRICTED_TO_SINGLE_PROJECT = [
//     "ul.susten",
//     "waaree.susten",
//     "rayzon.susten",
//   ];

//   const shouldShowSingleProject = USERNAMES_RESTRICTED_TO_SINGLE_PROJECT.includes(
//     username?.toLowerCase()
//   );

//   const toggleProfileDropdown = () => {
//     setProfileDropdownOpen(!profileDropdownOpen);
//   };

//   const handleClickOutside = (event) => {
//     if (
//       !event.target.closest("#profile-dropdown") &&
//       !event.target.closest("#profile-dropdown-menu")
//     ) {
//       setProfileDropdownOpen(false);
//     }
//   };

//   useEffect(() => {
//     if (profileDropdownOpen) {
//       document.addEventListener("click", handleClickOutside);
//     } else {
//       document.removeEventListener("click", handleClickOutside);
//     }
//     return () => document.removeEventListener("click", handleClickOutside);
//   }, [profileDropdownOpen]);

//   // Fetch projects (same as before)
//   useEffect(() => {
//     const fetchProjects = async () => {
//       try {
//         const response = await apiClient.get(`get_project_names`);
//         const formattedProjects = response.data.map((project) => ({
//           id: project.project_id,
//           name: project.project_name,
//         }));
//         setProjects(formattedProjects);

//         const storedProjectId = localStorage.getItem("selectedProject");
//         const storedProjectName = localStorage.getItem("selectedProjectName");

//         if (shouldShowSingleProject) {
//           const nhpcProject = formattedProjects.find(p => p.name === "NHPC_300MW");
//           if (nhpcProject) {
//             setSelectedProject(nhpcProject.name);
//             localStorage.setItem("selectedProject", nhpcProject.id);
//             localStorage.setItem("selectedProjectName", nhpcProject.name);
//           }
//         } else if (storedProjectName && formattedProjects.some(p => p.name === storedProjectName)) {
//           setSelectedProject(storedProjectName);
//         } else if (formattedProjects.length > 0) {
//           setSelectedProject(formattedProjects[0].name);
//           localStorage.setItem("selectedProject", formattedProjects[0].id);
//           localStorage.setItem("selectedProjectName", formattedProjects[0].name);
//         }
//       } catch (error) {
//         console.error("Error fetching projects:", error);
//       }
//     };

//     fetchProjects();
//   }, [shouldShowSingleProject, baseURL]);

//   const handleProjectChange = (e) => {
//     const selectedName = e.target.value;
//     if (shouldShowSingleProject && selectedName !== "NHPC_300MW") return;

//     const project = projects.find(p => p.name === selectedName);
//     if (project) {
//       setSelectedProject(selectedName);
//       localStorage.setItem("selectedProject", project.id);
//       localStorage.setItem("selectedProjectName", project.name);
//       window.location.reload();
//     }
//   };

//   // KEYCLOAK LOGOUT — CLEAN & POWERFUL
//   const handleLogout = () => {
//     // Optional: clean local state
//     localStorage.removeItem("selectedProject");
//     localStorage.removeItem("selectedProjectName");
//     sessionStorage.removeItem("username");

//     // This does full Keycloak logout + redirect
//     keycloak?.logout({
//       redirectUri: window.location.origin + "/"  // ← back to home (or "/login" if you have one)
//     });
//   };

//   const filteredProjects = shouldShowSingleProject
//     ? projects.filter(p => p.name === "NHPC_300MW")
//     : projects;

//   return (
//     <nav
//       className="fixed top-0 left-0 right-0 z-50 mb-10 bg-white border-b border-gray-200 shadow-sm transition-all duration-300"
//       style={{
//         marginLeft: sidebarOpen ? "300px" : "60px",
//         width: sidebarOpen ? "calc(100% - 300px)" : "calc(100% - 60px)",
//       }}
//     >
//       <div className="flex items-center justify-between h-16 px-6">
//         <div className="flex-shrink-0">
//           <img src={Logo} alt="Logo" className="h-10 w-auto" />
//         </div>

//         <div className="flex-1 max-w-md mx-8">
//           <select
//             value={selectedProject}
//             onChange={handleProjectChange}
//             disabled={shouldShowSingleProject}
//             className={`
//               w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border 
//               ${shouldShowSingleProject ? 'border-gray-300 bg-gray-50 cursor-not-allowed' : 'border-gray-300 hover:border-gray-400'}
//               rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
//               transition-all duration-200
//             `}
//             title={shouldShowSingleProject ? "Access restricted to NHPC_300MW project" : ""}
//           >
//             {!shouldShowSingleProject && (
//               <option value="">Select Project</option>
//             )}
//             {filteredProjects.map((project) => (
//               <option key={project.id} value={project.name}>
//                 {project.name}
//               </option>
//             ))}
//           </select>
//         </div>

//         <div className="relative">
//           <button
//             id="profile-dropdown"
//             onClick={toggleProfileDropdown}
//             className="flex items-center space-x-3 text-gray-700 hover:text-gray-900 focus:outline-none transition"
//           >
//             <div className="w-10 h-10 rounded-full bg-gradient-to-r from-gray-500 to-gray-600 flex items-center justify-center text-white font-semibold text-sm">
//               {username?.[0]?.toUpperCase() || "U"}
//             </div>
//             <span className="hidden md:block text-sm font-medium">{username || "User"}</span>
//             <svg
//               className={`w-4 h-4 transition-transform ${profileDropdownOpen ? "rotate-180" : ""}`}
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
//             </svg>
//           </button>

//           {profileDropdownOpen && (
//             <div
//               id="profile-dropdown-menu"
//               className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-10"
//             >
//               <div className="px-4 py-3 border-b border-gray-100">
//                 <p className="text-sm font-semibold text-gray-900">{username || "User"}</p>
//                 <p className="text-xs text-gray-500">User Account</p>
//               </div>
//               <button
//                 onClick={handleLogout}
//                 className="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 transition"
//               >
//                 Logout
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default Navbar;